import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { printSettingsForm2ApiMapper } from '../../../components/DocumentEditor/mappers/print-settings.form2api.mapper';
import type { OnSavePrintSettingsHandler } from '../../../components/DocumentEditor/types/props.type';

import { useUpdateReportPrintSettingsMutation } from './useUpdatePrintSettingsMutation.hook';
import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly missionReportId: Id;
}

export const useSavePrintSettingsHandler = ({
  missionReportId,
}: Readonly<Params>) => {
  const { invalidateQueries } = useQueryInvalidation(missionReportId);
  const { mutateAsync: updatePrintSettings } =
    useUpdateReportPrintSettingsMutation();

  const onSavePrintSettings = useCallback<OnSavePrintSettingsHandler>(
    async (printSettings) => {
      await updatePrintSettings({
        printableId: missionReportId,
        printSettings: printSettingsForm2ApiMapper(printSettings),
      });
      invalidateQueries();
    },
    [invalidateQueries, missionReportId, updatePrintSettings],
  );

  return { onSavePrintSettings };
};
